<template>
  <div class="page">
    <el-tabs class="card-info shadow" v-model="activeTab" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="车损费率查询" name="one">
        <BaseSearch
          v-model="searchData"
          :formOptions="searchFormOption"
          @handleSearch="handleSearchA"
        >
        </BaseSearch>
		<el-button type="primary" @click="vehicleRate">
			新增车损费率
		</el-button>
		<!-- <el-button type="primary" @click="handleExport">
			设置费率折扣
		</el-button> -->
        <BaseTable
          ref="baseTableA"
          url="/admin/rate/vehicleList"
          :tableData.sync="tableDataA"
          :columns="columnsA"
          :searchParams="searchData"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="vehicleRate(row)"
              >修改</el-button
            >
            <!-- <el-button type="text" size="mini" @click="delA(row)"
              >删除</el-button
            > -->
          </template>
        </BaseTable>
      </el-tab-pane>
      <el-tab-pane label="三者费率查询" name="two">
        <BaseSearch
          v-model="searchData"
          :formOptions="searchFormOption"
          @handleSearch="handleSearchB"
        ></BaseSearch>
		<el-button type="primary" @click="threeRate">
			新增三者费率
		</el-button>
        <BaseTable
          ref="baseTableB"
          url="/admin/rate/vehicleList?type=1"
          :tableData.sync="tableDataB"
          :columns="columnsB"
          :searchParams="searchData"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="threeRate(row)"
              >修改</el-button
            >
          </template>
        </BaseTable>
      </el-tab-pane>
      <el-tab-pane label="驾乘费率查询" name="three">
        <BaseSearch
          v-model="searchData"
          :formOptions="searchFormOption"
          @handleSearch="handleSearchC"
        ></BaseSearch>
		<el-button type="primary" @click="drivingRate">
			新增驾乘费率
		</el-button>
        <BaseTable
          ref="baseTableC"
          url="/admin/rate/vehicleList?type=2"
          :tableData.sync="tableDataC"
          :columns="columnsC"
          :searchParams="searchData"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="drivingRate(row)"
              >修改</el-button
            >
          </template>
        </BaseTable>
      </el-tab-pane>

	  <el-tab-pane label="强制险" name="compulsory" v-if="site == 'https://fuwu6.xiaoxiaocx.com'">
        <BaseSearch
          v-model="searchData"
          :formOptions="searchFormOption"
          @handleSearch="handleSearchD"
        ></BaseSearch>
		<el-button type="primary" @click="compulsoryRate">
			新增强制险费率
		</el-button>
        <BaseTable
          ref="baseTableD"
          url="/admin/rate/vehicleList?type=3"
          :tableData.sync="tableDataD"
          :columns="columnsD"
          :searchParams="searchData"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="compulsoryRate(row)"
              >修改</el-button>
          </template>
        </BaseTable>
      </el-tab-pane>

	  <el-tab-pane label="车船税" name="vessels" v-if="site == 'https://fuwu6.xiaoxiaocx.com'">
        <BaseSearch
          v-model="searchData"
          :formOptions="searchFormOption"
          @handleSearch="handleSearchE"
        ></BaseSearch>
		<el-button type="primary" @click="vesselsRate">
			新增车船税费率
		</el-button>
        <BaseTable
          ref="baseTableE"
          url="/admin/rate/vehicleList?type=4"
          :tableData.sync="tableDataE"
          :columns="columnsE"
          :searchParams="searchData"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="vesselsRate(row)"
              >修改</el-button
            >
          </template>
        </BaseTable>
      </el-tab-pane>
    </el-tabs>
	<!-- 车损费率弹窗 -->
	<BaseDialog
	  :visible.sync="dialogVisibleOne"
	  title="车损费率"
	  @confirm="handleDialogConfirmOne"
	>
	  <BaseForm
	    ref="baseForm"
	    v-model="formData"
	    :formOptions="rateFormOption"
	    :rules="rulesOne"
	    itemWidth="100%"
		@formChange="formChange"
	  ></BaseForm>
	</BaseDialog>
	<!-- 三者费率弹窗 -->
	<BaseDialog
	  :visible.sync="dialogVisibleTwo"
	  title="三者费率"
	  @confirm="handleDialogConfirmTwo"
	>
	  <BaseForm
	    ref="baseForm"
	    v-model="formData"
	    :formOptions="threeFormOption"
	    :rules="rulesTwo"
	    itemWidth="100%"
		@formChange="formChange"
	  ></BaseForm>
	</BaseDialog>
	<!-- 驾乘费率弹窗 -->
	<BaseDialog
	  :visible.sync="dialogVisibleThree"
	  title="驾乘费率"
	  @confirm="handleDialogConfirmThree"
	>
	  <BaseForm
	    ref="baseForm"
	    v-model="formData"
	    :formOptions="drivingFormOption"
	    :rules="rulesThree"
	    itemWidth="100%"
		@formChange="formChange"
	  ></BaseForm>
	</BaseDialog>
	<!-- 强制险费率弹窗 -->
	<BaseDialog
	  :visible.sync="dialogVisibleFour"
	  title="强制险费率"
	  @confirm="handleDialogConfirmFour"
	>
	  <BaseForm
	    ref="baseForm"
	    v-model="formData"
	    :formOptions="compulsoryFormOption"
	    :rules="rulesFour"
	    itemWidth="100%"
		@formChange="formChange"
	  ></BaseForm>
	</BaseDialog>
	<!-- 车船税费率弹窗 -->
	<BaseDialog
	  :visible.sync="dialogVisibleFive"
	  title="车船税费率"
	  @confirm="handleDialogConfirmFive"
	>
	  <BaseForm
	    ref="baseForm"
	    v-model="formData"
	    :formOptions="vesselsFormOption"
	    :rules="rulesFive"
	    itemWidth="100%"
		@formChange="formChange"
	  ></BaseForm>
	</BaseDialog>
  </div>
</template>

<script>
import { searchFormOption,columnsA,columnsB,columnsC,columnsD,columnsE,rulesOne,rateFormOption,threeFormOption,rulesTwo,drivingFormOption,rulesThree,compulsoryFormOption,rulesFour,vesselsFormOption,rulesFive } from "./columns";
import Cookies from 'js-cookie'

export default {
  data() {
    return {
	  activeTab: 'one',
      searchData: {},
      tableDataA: [],
	  tableDataB: [],
	  tableDataC: [],
	  tableDataD: [],
	  tableDataE: [],
	  regionOptions: [],
	  dialogVisibleOne: false,
	  dialogVisibleTwo: false,
	  dialogVisibleThree: false,
	  dialogVisibleFour: false,
	  dialogVisibleFive: false,
	  formData: {
		  id: 0,
		  energyType: '',
		  rateRegion: '',
		  nature: '',
		  carType: '',
	  },
	  energyType: [{'value':'燃油'},{'value':'天然气'},{'value':'电动'},{'value':'混合动力'},{'value':'其他'}],
	  carType:[],
	  nature:[],
	  typeOptions: [
		{value: 0, label: '1年未出险'},
		{value: 1, label: '2年未出险'},
		{value: 2, label: '3年未出险'},
		{value: 3, label: '上年出险1次'},
		{value: 4, label: '上年出险2次'},
		{value: 5, label: '上年出险3次及以上或发生死亡事故'},
	  ],
	  site: '',
    };
  },
  computed: {
    searchFormOption,
	columnsA,
	columnsB,
	columnsC,
	columnsD,
	columnsE,
	rulesOne,
	rulesTwo,
	rulesThree,
	rulesFour,
	rulesFive,
	rateFormOption,
	threeFormOption,
	drivingFormOption,
	compulsoryFormOption,
	vesselsFormOption,
  },
  created() {
    this.site = Cookies.get('site')
	  // 获取地区
  	  this.getRegion();
	  // 获取使用性质
	  this.getNature();
  },
  methods: {
	  // 获取地区
	  getRegion(){
	  	const arr = [];
	  	this.$api.post("/admin/org/getRegion", {}).then((res) => {
	  		if(res.data){
	  			res.data.forEach((v)=>{
	  				this.regionOptions.push(v);
	  			})
	  		}
	  	});
	  },
	  // 获取使用性质
	  getNature(){
	  	const arr = [];
	  	this.$api.post("/admin/rate/getNature", {}).then((res) => {
	  		if(res.data){
	  			res.data.forEach((v)=>{
	  				this.nature.push({'value':v.title});
	  			})
	  		}
	  	});
	  },
    handleSearchA() {
      this.$refs.baseTableA.searchData();
    },
	handleSearchB() {
	  this.$refs.baseTableB.searchData();
	},
	handleSearchC() {
	  this.$refs.baseTableC.searchData();
	},
	handleSearchD() {
	  this.$refs.baseTableD.searchData();
	},
	handleSearchE() {
	  this.$refs.baseTableE.searchData();
	},
	// 新增（修改）车损费率
	vehicleRate(row) {
		this.dialogVisibleOne = true;
		if(row){
			this.formData = { ...row };
		}
	},
	// 新增（修改）三者费率
	threeRate(row) {
		this.dialogVisibleTwo = true;
		if(row){
			this.formData = { ...row };
		}
	},
	// 新增（修改）驾乘费率
	drivingRate(row) {
		this.dialogVisibleThree = true;
		if(row){
			this.formData = { ...row };
		}
	},
	// 新增（修改）强制险费率
	compulsoryRate(row) {
		this.dialogVisibleFour = true;
		if(row){
			this.formData = { ...row };
		}
	},
	// 新增（修改）车船税费率
	vesselsRate(row) {
		this.dialogVisibleFive = true;
		if(row){
			this.formData = { ...row };
		}
	},
	// 车损费率提交
	handleDialogConfirmOne(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/rate/setRate', { 
				  'id': data.id,
				  'energyType': data.energyType,
				  'rateRegion': data.rateRegion,
				  'nature': data.nature,
				  'carType': data.carType,
				  'useYears': data.useYears,
				  'basicPremium': data.basicPremium,
				  'rate': data.rate
			  }, '车损费率提交');
		      this.dialogVisibleOne = false;
		      this.handleSearchA();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
	// 三者费率提交
	handleDialogConfirmTwo(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/rate/setThreeRate', { 
				  'id': data.id,
				  'energyType': data.energyType,
				  'rateRegion': data.rateRegion,
				  'nature': data.nature,
				  'carType': data.carType,
				  'coverage': data.coverage,
				  'standardStyle': data.standardStyle
			  }, '三者费率提交');
		      this.dialogVisibleTwo = false;
		      this.handleSearchB();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
	// 驾乘费率提交
	handleDialogConfirmThree(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/rate/setDrivingRate', { 
				  'id': data.id,
				  'energyType': data.energyType,
				  'rateRegion': data.rateRegion,
				  'nature': data.nature,
				  'carType': data.carType,
				  'driverRate': data.driverRate,
				  'passengerRate': data.passengerRate
			  }, '驾乘费率提交');
		      this.dialogVisibleThree = false;
		      this.handleSearchC();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
	// 强制险费率提交
	handleDialogConfirmFour(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/rate/setDrivingRate', { 
				  'id': data.id,
				  'energyType': data.energyType,
				  'rateRegion': data.rateRegion,
				  'nature': data.nature,
				  'carType': data.carType,
				  'driverRate': data.driverRate,
				  'passengerRate': data.passengerRate
			  }, '驾乘费率提交');
		      this.dialogVisibleThree = false;
		      this.handleSearchC();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
	// 车船税费率提交
	handleDialogConfirmFive(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/rate/setDrivingRate', { 
				  'id': data.id,
				  'energyType': data.energyType,
				  'rateRegion': data.rateRegion,
				  'nature': data.nature,
				  'carType': data.carType,
				  'driverRate': data.driverRate,
				  'passengerRate': data.passengerRate
			  }, '驾乘费率提交');
		      this.dialogVisibleThree = false;
		      this.handleSearchC();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
	// 下拉框更新
	formChange (...val) {
	   if (val[1] == 'nature') {
		  this.carType = [];
		  delete this.formData.carType;
		  this.$api.post("/admin/rate/getNature", {'title': val[0]}).then((res) => {
		  	if(res.data){
		  		res.data.forEach((v)=>{
		  			this.carType.push({'value':v.title,'label':v.id});
		  		})
		  	}
		  });
		}
		
	},
	// tab切换页
	handleClick(){
		//this.searchData = {};
		if(this.activeTab == 'one'){
			this.handleSearchA();
		}
		if(this.activeTab == 'two'){
			this.handleSearchB();
		}
		if(this.activeTab == 'three'){
			this.handleSearchC();
		}
	}
  },
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;
}
</style>